/* global liveagent */
// eslint-disable-next-line
import { h, Component } from 'preact';
import classNames from 'classnames';
import axios from 'axios';
import PropTypes from 'prop-types';

import styles from './index.scss';
// import config from './chat-config.json';
import IconDialogue from './icon-dialogue';

import MobilePopup from './components/MobilePopup';

import { CHAT_ENABLED_PAGES, API_CHAT_CONFIG_URL, DEFAULT_SITE_ID } from '../../../consts';

function isChatEnabledForPage() {
    return !!CHAT_ENABLED_PAGES.find(urlRx => !!window.location.pathname.match(urlRx));
}

class ChatButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isDesktop: true,
            showModalPopup: false,
            chatEnabled: isChatEnabledForPage(),
            agentOnline: false,
            configLoaded: false,
            libraryLoaded: false,
            chatInitialized: false,
            config: {
                // "siteChatInfo": {
                //     "chatLiveAgentDeploymentID": "572120000004FwY",
                //     "countryName": "United States",
                //     "chatButtonID": "573A000000005Cl",
                //     "countryCode": "US",
                //     "chatIsOnline":
                //         "Sales Support chat is <span class=\"chat-button-tooltip__status\">online</span>",
                //     "chatIsOffline":
                //         "Sales Support chat is currently <span class=\"chat-button-tooltip__status\">offline</span>",
                //     "helplineTimeMsg": "Mon-Fri 8am to 8pm EST",
                //     "name": "APC US Store"
                // },
                // "chatOrganizationID": "00Dq00000000OOF",
                // "chatJsURL": "https://c.la2-c2-iad.salesforceliveagent.com/content/g/js/42.0/deployment.js",
                // "chatAgentURL": "https://d.la2-c2-iad.salesforceliveagent.com/chat"
            },
        };
    }

    loadLibrary() {
        if (typeof liveagent !== 'undefined') {
            this.setState({ libraryLoaded: true });
            return;
        }
        // TODO: check if script exists on the page
        const s = document.createElement('script');
        s.src = this.state.config.chatJsURL;
        s.onload = () => {
            this.setState({
                libraryLoaded: true,
            });
        };
        document.head.appendChild(s);
    }

    loadConfig() {
        axios
            .get(API_CHAT_CONFIG_URL, {
                params: {
                    pushSite: window.apcSiteId || DEFAULT_SITE_ID,
                    ...(window.APC_CATEGORY_ID ? { categoryId: window.APC_CATEGORY_ID } : {}),
                },
            })
            .then(({ data: config }) => {
                // handle success
                this.setState(
                    {
                        config,
                        configLoaded: true,
                    },
                    () => {
                        this.loadLibrary();
                    },
                );
            })
            .catch(error => {
                console.log(error);
            });
    }

    mqListener = mediaObject => {
        this.setState({
            isDesktop: mediaObject.matches,
        });
    };

    componentDidMount() {
        if (this.state.chatEnabled) {
            this.loadConfig();
        }

        this.mediaQueryObject = window.matchMedia('(min-width: 720px)');
        this.mediaQueryObject.addListener(this.mqListener);

        // first execution of listener
        this.mqListener(this.mediaQueryObject);
    }

    componentWillUnmount() {
        this.mediaQueryObject.removeListener(this.mqListener);
    }

    componentDidUpdate() {
        const { libraryLoaded, configLoaded, chatInitialized } = this.state;
        if (libraryLoaded && configLoaded && !chatInitialized) {
            this.initLiveAgent();
        }
    }

    initLiveAgent() {
        const {
            siteChatInfo: {
                chatLiveAgentDeploymentID,
                countryName,
                chatButtonID,
                countryCode,
                name,
            },
            chatAvailable,
            chatOrganizationID,
            chatAgentURL,
        } = this.state.config;

        if (typeof liveagent === 'undefined') {
            console.error('Liveagent library is not found on the page');
            return;
        }

        if (!chatAvailable) {
            console.warn('Chat is not enabled on this page or site');
            return;
        }

        liveagent.addButtonEventHandler(chatButtonID, ev => {
            switch (ev) {
                case liveagent.BUTTON_EVENT.BUTTON_AVAILABLE:
                    this.setState({ agentOnline: true });
                    break;
                case liveagent.BUTTON_EVENT.BUTTON_UNAVAILABLE:
                    this.setState({ agentOnline: false });
                    break;
                case liveagent.BUTTON_EVENT.BUTTON_ACCEPTED:
                    // opening chat window or
                    // accpeted automated chat window invitation
                    break;
                case liveagent.BUTTON_EVENT.BUTTON_REJECTED:
                    // rejected automated chat window
                    break;
                default:
                    console.error('Unknown liveagent button event: ', ev);
            }
        });

        liveagent.setChatWindowHeight(450);
        liveagent.setChatWindowWidth(450);
        liveagent
            .addCustomDetail('Web Country', countryName, true)
            .saveToTranscript('SuppliedCountry__c');
        liveagent
            .addCustomDetail('Country Code', countryCode, false)
            .saveToTranscript('CountryCode__c');
        liveagent
            .addCustomDetail('Referring Site Name', name, true)
            .saveToTranscript('ReferringSiteName__c');
        liveagent
            .addCustomDetail('Referring Page', document.title, true)
            .saveToTranscript('ReferringPage__c');
        liveagent
            .addCustomDetail('Referring Page URL', window.location.href, true)
            .saveToTranscript('ReferringPageURL__c');
        liveagent.addCustomDetail('Chat Type', 'Chat Button', true).saveToTranscript('ChatType__c');
        liveagent
            .addCustomDetail('Chat Audience', 'Business', false)
            .saveToTranscript('TargetAudience__c');

        liveagent.showWhenOnline(chatButtonID, this.btnDummyOnline);
        liveagent.showWhenOffline(chatButtonID, this.btnDummyOffline);
        try {
            liveagent.init(chatAgentURL, chatLiveAgentDeploymentID, chatOrganizationID);
        } catch (e) {
            console.error('liveagent init error: ', e);
        }

        if (window.localStorage.getItem('APC_ENABLE_CHAT_LOGGING')) {
            liveagent.enableLogging();
        }

        this.setState({ chatInitialized: true });
    }

    handleBtnClick = () => {
        const { chatInitialized, agentOnline, config } = this.state;

        if (chatInitialized && agentOnline) {
            liveagent.startChat(config.siteChatInfo.chatButtonID);
        } else {
            this.setState({
                showModalPopup: true,
            });
        }
    };

    removeFocus = () => {
        const el = document.activeElement;
        if (el && el.classList.contains(styles.chatButton)) {
            el.blur();
        }
    };

    handleMobilePopupClose = e => {
        e.stopPropagation();
        this.setState({
            showModalPopup: false,
        });
    };

    render() {
        const {
            siteChatInfo: { chatIsOnline, chatIsOffline, chatButtonID } = {},
            helplineTimeMsg,
            chatAvailable,
        } = this.state.config;

        if (!this.state.chatEnabled || !chatAvailable) {
            return null;
        }

        const buttonWrapperClasses = classNames({
            [styles.chatButtonWrapper]: true,
            [styles.online]: this.state.agentOnline,
            'analytics-chat-online': this.state.agentOnline,
            'analytics-chat': true,
            [styles.shift]: this.props.isBannerShow,
        });
        const chatButtonClasses = classNames({
            [styles.chatButton]: true,
        });
        const availabilityTitle = this.state.agentOnline ? chatIsOnline : chatIsOffline;

        const availabilityTimeRage = this.state.agentOnline ? '' : helplineTimeMsg;

        const showMobileModalPopup = this.state.showModalPopup && !this.state.isDesktop;

        return (
            <div onClick={this.handleBtnClick} className={buttonWrapperClasses} {...this.props}>
                <div style={{ display: 'none' }}>
                    <div
                        ref={el => {
                            this.btnDummyOnline = el;
                        }}
                        id={`liveagent_button_online_${chatButtonID}`}
                    />
                    <div
                        ref={el => {
                            this.btnDummyOffline = el;
                        }}
                        id={`liveagent_button_offline_${chatButtonID}`}
                    />
                </div>
                <button onClick={this.removeFocus} className={chatButtonClasses} aria-label="">
                    <IconDialogue />
                </button>
                {this.state.configLoaded ? (
                    <div className={styles.tooltip}>
                        <div
                            className={styles.availability}
                            dangerouslySetInnerHTML={{ __html: availabilityTitle }}
                        />
                        {availabilityTimeRage ? (
                            <div dangerouslySetInnerHTML={{ __html: availabilityTimeRage }} />
                        ) : null}
                    </div>
                ) : null}
                {showMobileModalPopup ? (
                    <MobilePopup heading={availabilityTitle} onClose={this.handleMobilePopupClose}>
                        <div dangerouslySetInnerHTML={{ __html: availabilityTimeRage }} />
                    </MobilePopup>
                ) : null}
            </div>
        );
    }
}
ChatButton.propTypes = {
    isBannerShow: PropTypes.bool,
};

export default ChatButton;
